import { Components, inputLabelClasses, Theme } from '@mui/material';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: ({ theme }) => {
      const fallbackLabelColor = theme.featureFlags.panwRebrandStubYear
        ? theme.palette.text.placeholder
        : theme.palette.grey[600];
      return {
        color: theme.palette.input.labelColor ?? fallbackLabelColor,
        ...(theme.featureFlags.panwRebrandStubYear && {
          [`&.${inputLabelClasses.error}`]: {
            color: theme.palette.input.errorColor,
          },
        }),
      };
    },
    sizeSmall: {
      top: '-3px',
    },
    shrink: {
      top: '0px',
    },
  },
};
